module.exports = __webpack_public_path__ + "static/media/reachcustomermain2.735a5c6a.png";